import React from 'react'

import SegmentData from './SegmentData'

const SegmentingPage = ({ match }) => (
  <div>
    <div className="container">
      <SegmentData search={match.params.request} />
    </div>
  </div>
)

export default SegmentingPage;


// WEBPACK FOOTER //
// ./src/components/SegmentingPage.js